import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/vesselschedule/carrierenroll'
import pathMap from 'src/paths/PathMap_VesselSchedule'

class CarrierEnrollRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.CARRIER_ENROLL_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.CARRIER_ENROLL_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.CARRIER_ENROLL_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.CARRIER_ENROLL_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default CarrierEnrollRoute
